var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangel2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 338,
    viewBox: "0 0 382 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.34 64.2249L186.013 41.5368L197.868 158.946L116.34 64.2249Z",
    fill: "url(#paint0_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.376 64.4786L109.51 131.638L197.868 158.801L116.376 64.4786Z",
    fill: "url(#paint1_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.817 135.382L381.442 199.05L303.336 204.108L372.817 135.382Z",
    fill: "url(#paint2_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.823 134.999L329.175 125.571L303.323 204.108L372.823 134.999Z",
    fill: "url(#paint3_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.884 206.357L301.56 259.292L229.168 325.145L256.884 206.357Z",
    fill: "url(#paint4_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.97 205.42L209.506 230.896L229.225 324.752L256.97 205.42Z",
    fill: "url(#paint5_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8111 154.587L122.756 183.754L62.3746 273.58L66.8111 154.587Z",
    fill: "url(#paint6_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6108 149.667L24.6986 193.362L64.0085 271.36L68.6108 149.667Z",
    fill: "url(#paint7_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.706 89.1934L299.117 146.263L228.255 158.453L286.706 89.1934Z",
    fill: "url(#paint8_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.718 88.842L246.238 84.5368L228.249 158.452L286.718 88.842Z",
    fill: "url(#paint9_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.872 192.256L174.643 238.365L130.83 240.631L166.872 192.256Z",
    fill: "url(#paint10_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.881 192.079L137.078 191.826L130.829 240.629L166.881 192.079Z",
    fill: "url(#paint11_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1752 113.111L56.323 133.392L44.1052 91.6037L86.1752 113.111Z",
    fill: "url(#paint12_linear_59_2470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1753 113.111L79.1065 84.2138L44.1053 91.6036L86.1753 113.111Z",
    fill: "url(#paint13_linear_59_2470)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_2470",
    x1: 185.036,
    y1: 41.5893,
    x2: 104.882,
    y2: 61.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_2470",
    x1: 184.257,
    y1: 60.8464,
    x2: 99.3741,
    y2: 88.8049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_2470",
    x1: 369.711,
    y1: 135.547,
    x2: 299.282,
    y2: 166.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_2470",
    x1: 362.964,
    y1: 123.764,
    x2: 295.133,
    y2: 146.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_2470",
    x1: 290.625,
    y1: 204.541,
    x2: 216.52,
    y2: 221.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_2470",
    x1: 250.412,
    y1: 205.775,
    x2: 200.877,
    y2: 213.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_2470",
    x1: 100.718,
    y1: 138.829,
    x2: 25.6978,
    y2: 179.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_2470",
    x1: 61.9048,
    y1: 152.79,
    x2: 9.7158,
    y2: 175.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_2470",
    x1: 288.465,
    y1: 89.0996,
    x2: 222.475,
    y2: 115.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_2470",
    x1: 278.453,
    y1: 82.8103,
    x2: 220.138,
    y2: 100.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_2470",
    x1: 167.897,
    y1: 192.201,
    x2: 125.998,
    y2: 206.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_2470",
    x1: 161.806,
    y1: 190.499,
    x2: 125.405,
    y2: 200.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_2470",
    x1: 80.0738,
    y1: 90.4349,
    x2: 40.8462,
    y2: 104.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_2470",
    x1: 79.9686,
    y1: 84.1858,
    x2: 44.8607,
    y2: 102.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangel2);
export default __webpack_public_path__ + "static/media/triangel2.6c963f43c2cfcfb204fd7a20e1033118.svg";
export { ForwardRef as ReactComponent };